export const erpEquivalenciesTypes = {
  HANDLE_ERP_EQUIVALENCIES_INPUTS: 'HANDLE_ERP_EQUIVALENCIES_INPUTS',
  GET_ERP_EQUIVALENCIES: 'GET_ERP_EQUIVALENCIES',
  GET_BANK_REFERENCES: 'GET_BANK_REFERENCES',
  GET_DATA_FISCAL: 'GET_DATA_FISCAL',
  GET_CREDIT_CONDITIONS: 'GET_CREDIT_CONDITIONS',
  GET_SHIP_TO_ADDRESS: 'GET_SHIP_TO_ADDRESS',
  RESTORE_INITIAL: "RESTORE_INITIAL",
};